import { ColorHelper, ScaleType, Color, StringOrNumberOrDate } from "@swimlane/ngx-charts";

export class KilowantColorHelper extends ColorHelper {
    addLabels: string[] = [];
    addColors: string[] = [];

    constructor(colorHelper: ColorHelper, scheme: string | Color, type: ScaleType, addLabels: string[], addColors: string[]) {
        super(scheme, type, colorHelper.domain, colorHelper.customColors);
        for (var i = 0; i < addLabels.length; i++) {
            this.addColor(addLabels[i], addColors[i]);
        }
    }

    addColor(label: string, color: string): void {
        var testVal = <string>label;
        testVal = testVal.replace(/\*.*$/, "");
        testVal = testVal + " ";
        testVal = testVal.replace(/\s*\$.+/, " ");
        testVal = testVal.trim();

        if (!this.addLabels.includes(testVal)) {
            this.addLabels.push(testVal);
            this.addColors.push(color);
        }
    }

    getColor(value: StringOrNumberOrDate): string {
        var testVal = <string>value;
        testVal = testVal.replace(/\*.*$/, "");
        testVal = testVal + " ";
        testVal = testVal.replace(/\s*\$.+/, " ");
        testVal = testVal.trim();
        var pos = this.addLabels.indexOf(testVal);
        if (pos > -1) {
            return this.addColors[pos];
        }
        return super.getColor(testVal);
    }
}